var map = {
	"./change/change.module": [
		"./src/app/features/profile/change/change.module.ts",
		"change-change-module~features-account-account-module~features-customerstatement-customerstatement-mo~f43af57d",
		"change-change-module~features-customerstatement-customerstatement-module~features-product-product-mo~d8af35e1",
		"change-change-module~features-customerstatement-customerstatement-module",
		"common",
		"change-change-module"
	],
	"./features/account/account.module": [
		"./src/app/features/account/account.module.ts",
		"change-change-module~features-account-account-module~features-customerstatement-customerstatement-mo~f43af57d",
		"common",
		"features-account-account-module"
	],
	"./features/auth/auth.module": [
		"./src/app/features/auth/auth.module.ts",
		"features-auth-auth-module"
	],
	"./features/customerstatement/customerstatement.module": [
		"./src/app/features/customerstatement/customerstatement.module.ts",
		"change-change-module~features-account-account-module~features-customerstatement-customerstatement-mo~f43af57d",
		"change-change-module~features-customerstatement-customerstatement-module~features-product-product-mo~d8af35e1",
		"change-change-module~features-customerstatement-customerstatement-module",
		"common",
		"features-customerstatement-customerstatement-module"
	],
	"./features/dashboard/dashboard.module": [
		"./src/app/features/dashboard/dashboard.module.ts",
		"change-change-module~features-account-account-module~features-customerstatement-customerstatement-mo~f43af57d",
		"common",
		"features-dashboard-dashboard-module"
	],
	"./features/product/product.module": [
		"./src/app/features/product/product.module.ts",
		"change-change-module~features-customerstatement-customerstatement-module~features-product-product-mo~d8af35e1",
		"common",
		"features-product-product-module"
	],
	"./features/profile/profile.module": [
		"./src/app/features/profile/profile.module.ts",
		"change-change-module~features-customerstatement-customerstatement-module~features-product-product-mo~d8af35e1",
		"common",
		"features-profile-profile-module"
	],
	"./features/report/report.module": [
		"./src/app/features/report/report.module.ts",
		"change-change-module~features-account-account-module~features-customerstatement-customerstatement-mo~f43af57d",
		"common",
		"features-report-report-module"
	],
	"./features/spotprice/spotprice.module": [
		"./src/app/features/spotprice/spotprice.module.ts",
		"change-change-module~features-account-account-module~features-customerstatement-customerstatement-mo~f43af57d",
		"common",
		"features-spotprice-spotprice-module"
	],
	"./features/trade/trade.module": [
		"./src/app/features/trade/trade.module.ts",
		"change-change-module~features-customerstatement-customerstatement-module~features-product-product-mo~d8af35e1",
		"common",
		"features-trade-trade-module"
	],
	"./forgot/forgot.module": [
		"./src/app/features/auth/forgot/forgot.module.ts",
		"change-change-module~features-account-account-module~features-customerstatement-customerstatement-mo~f43af57d",
		"common",
		"forgot-forgot-module"
	],
	"./locked/locked.module": [
		"./src/app/features/auth/locked/locked.module.ts",
		"locked-locked-module"
	],
	"./login/login.module": [
		"./src/app/features/auth/login/login.module.ts",
		"change-change-module~features-account-account-module~features-customerstatement-customerstatement-mo~f43af57d",
		"common",
		"login-login-module"
	],
	"./product-list/list.module": [
		"./src/app/features/product/product-list/list.module.ts",
		"change-change-module~features-account-account-module~features-customerstatement-customerstatement-mo~f43af57d",
		"change-change-module~features-customerstatement-customerstatement-module~features-product-product-mo~d8af35e1",
		"common",
		"product-list-list-module"
	],
	"./register/register.module": [
		"./src/app/features/auth/register/register.module.ts",
		"register-register-module"
	],
	"./trade-details/details.module": [
		"./src/app/features/trade/trade-details/details.module.ts",
		"common",
		"trade-details-details-module"
	],
	"./trade-list/list.module": [
		"./src/app/features/trade/trade-list/list.module.ts",
		"change-change-module~features-account-account-module~features-customerstatement-customerstatement-mo~f43af57d",
		"common",
		"trade-list-list-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;